import React, { useEffect } from 'react';
import { Box, InfoBanner, Link } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { IneligibleLinesReason } from 'journey/productDetails/typings';
import { getIneligibleWarningMessage } from 'journey/productDetails/utils/getIneligibleWarningMessage/getIneligibleWarningMessage.utils';
import { trackIneligibleWarningEvent } from 'journey/productDetails/utils/trackIneligibleWarningEvent.utils';
import { MESSAGE_US } from 'shared/constants';

interface IneligibleWarningProps {
  hasLines: boolean;
  reason?: IneligibleLinesReason;
}

const IneligibleWarning = ({ hasLines, reason }: IneligibleWarningProps) => {
  const message = getIneligibleWarningMessage({ hasLines, reason });

  useEffect(() => {
    trackIneligibleWarningEvent(message);
  }, [hasLines, reason]);

  return (
    <Box mb="s2" pt="s2">
      <InfoBanner variant="WARN">
        {hasLines ? (
          <>{message}</>
        ) : (
          <>
            {message}
            <br />
            <LinkRegion regionId="planSelector.changePlan.message">
              <Link href={MESSAGE_US}>Message Us</Link>
            </LinkRegion>
          </>
        )}
      </InfoBanner>
    </Box>
  );
};

export default IneligibleWarning;
